export const removeWhiteSpaces = (text: string) => {
  return text.replace(/\s/g, '');
};
